import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { getTrainer } from "./actionCreator";

export const TrainerSlice = createSlice({
    name: "trainer",
    initialState,
    reducers: {
        setSearchKey: (state, action) => {
            console.log("trainer // action in setsearchkey is : ", action);
            state.trainers.searchTerm = action.payload;
        },
        setPaginationModel(state, action) {
            state.trainers.page = action.payload.page;
            state.trainers.limit = action.payload.pageSize;
        },
        resetPaginationModel(state, action) {
            state.trainers.page = 0;
            state.trainers.limit = 25;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTrainer.pending, (state) => {
                state.trainers.isLoading = true;
            })
            .addCase(getTrainer.fulfilled, (state, action) => {
                console.log("action in trainer is : ", action.payload.data);
                state.trainers.isLoading = false;
                state.trainers.stats = action.payload.data.payload.stats;
                state.trainers.TrainerList = action.payload.data.payload.trainers; // Access action.payload to get the response data
            })
            .addCase(getTrainer.rejected, (state, action) => {
                state.trainers.isLoading = false;
            });
    }
});

export default TrainerSlice.reducer; // Use 'reducer' instead of 'reducers'
export const { setSearchKey } = TrainerSlice.actions
